import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import Keycloak from 'keycloak-js';
import { RqaMenuComponent } from './app.menu';
import { ButtonComponent, IconComponent } from '@pansa/ui';

@Component({
  selector: 'rqa-sidebar',
  standalone: true,
  imports: [RqaMenuComponent, IconComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
<div
  class="layout-sidebar"
  [class.collapsed]="collapsed">

  <div class="menu-container">

  <div class="menu-top">

            <div class="p-lg d-flex justify-content-center">
              <button pui-button class="sidebar-toggle" (click)="toggleSidebar()">
                <pui-icon
                  [icon]="'menu-01'">
                </pui-icon>
              </button>
          </div>
  
    @if(!collapsed){    
    <div class="logo">

      <div class="logo-main"> 
            <img src="assets/svg/pansa-logo.svg" alt="Pansa logo" />
      </div>

      <div class="logo-subtitle">
        <span>WebRQA</span>
      </div>

    </div>
    }

      <rqa-menu
        [collapsed]="collapsed">
      </rqa-menu>

    </div>

    <div class="menu-footer">

      <div class="divider"></div>

      <div class="user-info-container">

        <div class="user-info">

          <div class="user-info-name">
            <span>{{ userName }}</span>
          </div>

          <div class="user-info-email">
            <span>{{ userEmail }}</span>
          </div>

        </div>

        <div class="logout-button">
          <button class="clean">
            <pui-icon
              [icon]="'log-out-01'"
              (click)="logout()">
            </pui-icon>
          </button>
        </div>

      </div>

    </div>

  </div>

</div>
  `
})
export class RqaSidebarComponent {
  keycloak = inject(Keycloak);

  userName: string = this.keycloak.tokenParsed?.name;
  userEmail: string = this.keycloak.tokenParsed?.email;

  collapsed =
    localStorage.getItem('sidebarCollapsed') === 'true';

  toggleSidebar() {
    this.collapsed = !this.collapsed;

    localStorage.setItem(
      'sidebarCollapsed',
      String(this.collapsed)
    );
  }

  logout() {
    this.keycloak.logout({ redirectUri: window.location.origin });
  }
}

